<div>
  <h1>{{ title }}</h1>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-description>Referenz</mat-panel-description>
    </mat-expansion-panel-header>
    <div [innerHTML]="manual"></div>
  </mat-expansion-panel>
  <form class="input-form" [formGroup]="form">
    <table class="mat-elevation-z8">
      <thead>
        <th></th>
        <th class="input-column head">Links</th>
        <th class="input-column head">Rechts</th>
      </thead>
      <tbody>
        @for (row of dataHtml; track row.name) {
          <tr>
            <td>
              <h3>{{ row.label }}</h3>
            </td>
            <td class="input-column">
              <div class="input">
                <input
                  [tabIndex]="startTabIndex + $index + 1"
                  [formControlName]="row.controlLeftName"
                  type="number"
                  appNumbersOnly
                  placeholder="" />
                @if (form.controls[row.controlLeftName].invalid) {
                  <mat-icon class="input-icon mat-mdc-form-field-error">error</mat-icon>
                }
                <mat-checkbox class="example-margin" [formControlName]="row.name + '_leftOvertime'"
                  >Zeit abgelaufen</mat-checkbox
                >
              </div>
              @if (form.controls[row.name + '_leftOvertime'].value === true) {
                <div class="input">
                  <input
                    name="leftOvertime"
                    [tabIndex]="startTabIndex + $index + 2"
                    [formControlName]="row.name + '_leftRest'"
                    type="number"
                    appNumbersOnly
                    placeholder="" />
                  @if (form.controls[row.name + '_leftRest'].invalid) {
                    <mat-icon class="input-icon mat-mdc-form-field-error">error</mat-icon>
                  }
                  <label class="label" for="leftOvertime">von 18 Punkten</label>
                </div>
              }
              @if (
                form.controls[row.controlLeftName].hasError('max') ||
                form.controls[row.name + '_leftRest'].hasError('max')
              ) {
                <mat-error class="input-error">Wert zu groß</mat-error>
              }
              @if (
                form.controls[row.controlLeftName].hasError('min') ||
                form.controls[row.name + '_leftRest'].hasError('min')
              ) {
                <mat-error class="input-error">Wert zu klein</mat-error>
              }
            </td>
            <td class="input-column">
              <div class="input">
                <input
                  [tabIndex]="startTabIndex + $index + 3"
                  [formControlName]="row.controlRightName"
                  type="number"
                  appNumbersOnly
                  placeholder="" />
                @if (form.controls[row.controlRightName].invalid) {
                  <mat-icon class="input-icon mat-mdc-form-field-error">error</mat-icon>
                }
                <mat-checkbox class="example-margin" [formControlName]="row.name + '_rightOvertime'"
                  >Zeit abgelaufen</mat-checkbox
                >
              </div>
              @if (form.controls[row.name + '_rightOvertime'].value === true) {
                <div class="input">
                  <input
                    name="rightOvertime"
                    [tabIndex]="startTabIndex + $index + 4"
                    [formControlName]="row.name + '_rightRest'"
                    type="number"
                    appNumbersOnly
                    placeholder="" />
                  @if (form.controls[row.name + '_rightRest'].invalid) {
                    <mat-icon class="input-icon mat-mdc-form-field-error">error</mat-icon>
                  }
                  <label class="label" for="rightOvertime">von 18 Punkten</label>
                </div>
              }
              @if (
                form.controls[row.controlRightName].hasError('max') ||
                form.controls[row.name + '_rightRest'].hasError('max')
              ) {
                <mat-error class="input-error">Wert zu groß</mat-error>
              }
              @if (
                form.controls[row.controlRightName].hasError('min') ||
                form.controls[row.name + '_rightRest'].hasError('min')
              ) {
                <mat-error class="input-error">Wert zu klein</mat-error>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    <!-- <mat-form-field class="note">
      <mat-label>Zusätzliche Hinweise (optional)</mat-label>
      <textarea [tabIndex]="startTabIndex + 5" type="text" matInput formControlName="note" placeholder=""></textarea>
    </mat-form-field> -->
  </form>
</div>
